module.exports = __webpack_public_path__ + "static/img/14000015.caa2a683.png";